module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-UPWORK.fb1e456f.png";